import { forwardRef, useRef } from 'react'

export interface IHeaderButton {
  children?: JSX.Element
  open?: (modal: JSX.Element) => void
  modal: JSX.Element
  onMouseEnter?: () => void
}

function Button({ children, open, modal, onMouseEnter }: IHeaderButton, ref: any) {
  const buttonRef = useRef<any>()

  const handleClick = (e: any) => {
    e.preventDefault()
    buttonRef.current.classList.toggle('active')
    if (open) open(modal)
  }
  return (
    <a
      className="topbar-btn"
      href=""
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      ref={(r) => {
        ref(r)
        buttonRef.current = r
      }}
    >
      {children}
    </a>
  )
}

export default forwardRef(Button)
